import columnWidget from './ColumnWidget/template'
import imageColumnWidget from './ImageColumnWidget/template'
import twoColumnWidget from './TwoColumnWidget/template'
import fortuneWheelWidget from './FortuneWheelWidget/template'
import stickyBarWidget from './StickyBarWidget/template'

// Make script on npm build which lops through all widget folders and makes a templateDefaults file #35
export default [columnWidget, imageColumnWidget, twoColumnWidget, fortuneWheelWidget, stickyBarWidget]
